import React from 'react';

import { FieldSet, Label, LabeledControl, Legend, Radio } from '@zillow/constellation';

import type { Section } from '../../models';
import { FEE_PAYMENT_TIME } from '../../constants/stringConstants';
import { getStartDayOfTheLeaseLabel } from '../../constants/functionConstants';

type Props = {
  label: string;
  firstChecked: boolean;
  secondChecked: boolean;
  onChange: (event: any) => void;
  section: Section;
  firstField?: string;
  secondField?: string;
};

export default function FeePaymentTime({
  label,
  firstChecked,
  secondChecked,
  onChange,
  section,
  firstField,
  secondField,
}: Props) {
  const firstFieldDisabled = firstField ? section.isFieldDisabled(firstField) : false;
  const secondFieldDisabled = secondField ? section.isFieldDisabled(secondField) : false;

  return (
    <FieldSet legend={<Legend>{label}</Legend>} disabled={firstFieldDisabled && secondFieldDisabled}>
      <LabeledControl
        controlId={FEE_PAYMENT_TIME.FIRST_PAY_ON_SIGN}
        label={<Label>Upon signing the lease</Label>}
        control={<Radio name="fee-payment-timing" checked={firstChecked} onChange={onChange} />}
        disabled={firstFieldDisabled}
      />
      <LabeledControl
        controlId={FEE_PAYMENT_TIME.FIRST_PAY_ON_LEASE_START}
        label={<Label>{getStartDayOfTheLeaseLabel(section)}</Label>}
        control={<Radio name="fee-payment-timing" checked={secondChecked} onChange={onChange} />}
        disabled={secondFieldDisabled}
      />
    </FieldSet>
  );
}
